import { Quote, Star, ExternalLink, ShieldCheck } from "lucide-react";

const reviews = [
  {
    id: "r1",
    title: "Complete bathroom design & re-fit",
    location: "PO15, Hampshire",
    project: "Bathroom Fitter",
    rating: 10,
    date: "Apr 2025",
    quote:
      "Would give C4 Plumbing a score of 15/10 — great customer service, great standard of finished work, very happy with the design and works carried out. Nothing was too much trouble and I was kept fully updated along the way.",
    initials: "VR",
  },
  {
    id: "r2",
    title: "Complete bathroom installation",
    location: "SO53, Hampshire",
    project: "Bathroom Fitter",
    rating: 10,
    date: "Mar 2025",
    quote:
      "Bailey and his team at C4 Plumbing did an absolutely amazing job of installing our main bathroom and en-suite. Punctual, tidy and polite. Communication from start to finish was great — 10/10 service and would highly recommend.",
    initials: "VR",
  },
  {
    id: "r3",
    title: "Lovely Bathroom",
    location: "PO13, Hampshire",
    project: "Bathroom Fitter",
    rating: 10,
    date: "Mar 2026",
    quote:
      "Bailey and Freddie and the whole team did a fabulous bathroom for us. Great workmanship, tidy, punctual, and kept us informed. Very professional. Nothing was too much trouble. So pleased.",
    initials: "C4",
  },
  {
    id: "r4",
    title: "Fantastic service at short notice",
    location: "PO16, Hampshire",
    project: "Toilet repair",
    rating: 10,
    date: "Oct 2024",
    quote:
      "Called C4 after someone recommended them. They were amazing — superb communication, on time and work was smooth and excellent quality. Both plumbers were very courteous and didn't leave a scrap of mess. Cannot recommend them enough!",
    initials: "VR",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 lg:py-32 bg-[#F5EED8]/60 c4-grain"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <span className="uppercase text-xs tracking-[0.3em] text-[#C9A24A] font-semibold">
              Customer Reviews
            </span>
            <h2
              data-testid="testimonials-title"
              className="mt-4 font-heading text-3xl lg:text-5xl text-[#1C2A39] font-medium tracking-tight"
            >
              Words from the homes we&apos;ve worked in.
            </h2>
          </div>

          <div
            data-testid="checkatrade-badge"
            className="lg:col-span-5 bg-white border border-[#E8E5DD] p-6 flex items-center gap-5"
          >
            <div className="w-14 h-14 grid place-items-center bg-[#1C2A39] text-white shrink-0">
              <ShieldCheck size={26} strokeWidth={1.5} />
            </div>
            <div className="flex-1">
              <div className="flex items-baseline gap-2">
                <span className="font-heading text-3xl text-[#1C2A39] font-semibold leading-none">
                  10
                </span>
                <span className="font-heading text-sm text-[#5C6670]">/10</span>
                <div className="flex ml-2">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      size={14}
                      strokeWidth={1.5}
                      fill="#C9A24A"
                      className="text-[#C9A24A]"
                    />
                  ))}
                </div>
              </div>
              <div className="mt-1 text-xs text-[#5C6670]">
                Based on <span className="font-semibold text-[#1C2A39]">32 verified reviews</span> on Checkatrade
              </div>
            </div>
            <a
              data-testid="checkatrade-link"
              href="https://www.checkatrade.com/trades/c4plumbingheatingltd"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center gap-1.5 text-xs font-heading font-semibold text-[#C9A24A] hover:text-[#B0893A]"
            >
              View
              <ExternalLink size={13} strokeWidth={1.75} />
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {reviews.map((r) => (
            <figure
              key={r.id}
              data-testid={`testimonial-${r.id}`}
              className="bg-white border border-[#E8E5DD] p-7 lg:p-9 relative"
            >
              <Quote
                size={36}
                strokeWidth={1.25}
                className="text-[#C9A24A]/30 absolute top-6 right-6"
              />
              <div className="flex items-center gap-2 mb-4">
                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      size={14}
                      strokeWidth={1.5}
                      fill="#C9A24A"
                      className="text-[#C9A24A]"
                    />
                  ))}
                </div>
                <span className="text-xs font-heading font-semibold text-[#1C2A39]">
                  {r.rating}/10
                </span>
              </div>
              <h3 className="font-heading text-lg text-[#1C2A39] font-semibold leading-snug">
                {r.title}
              </h3>
              <blockquote className="mt-3 text-[15px] text-[#1A1A1A] leading-relaxed">
                “{r.quote}”
              </blockquote>
              <figcaption className="mt-7 flex items-center justify-between gap-4 pt-5 border-t border-[#E8E5DD]">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 grid place-items-center bg-[#F5EED8] text-[#1C2A39] font-heading text-xs font-semibold tracking-wider">
                    {r.initials}
                  </div>
                  <div>
                    <div className="font-heading text-xs text-[#1C2A39] font-semibold">
                      {r.project} · {r.location}
                    </div>
                    <div className="text-[11px] text-[#5C6670] uppercase tracking-[0.15em]">
                      Verified · {r.date}
                    </div>
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            data-testid="testimonials-checkatrade-cta"
            href="https://www.checkatrade.com/trades/c4plumbingheatingltd/reviews"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-heading font-semibold text-[#1C2A39] hover:text-[#C9A24A] border-b border-[#E8E5DD] hover:border-[#C9A24A] pb-1 transition-colors"
          >
            Read all 32 reviews on Checkatrade
            <ExternalLink size={14} strokeWidth={1.75} />
          </a>
        </div>
      </div>
    </section>
  );
}
